import { ComponentType, useState } from "react";
import { CallSuportComponent, ICallSuportComponent } from "./CallSuportComponent";
import { HeaderMenuComponent, IHeaderMenuComponent } from "./HeaderMenuComponent";
import { Alert, AlertColor, Snackbar } from "@mui/material";

export interface MenuComponentProps {
    FooterComponent: ComponentType<ICallSuportComponent>;
    HeaderComponent: ComponentType<IHeaderMenuComponent>;
    setPopupOk: (set: boolean) => void;
    setAlertColor: (set: AlertColor) => void;
    setMessage: (set: string) => void;
    index: number;
}

export interface IRenderUserMenuOptions {
    MenuOptionComponent: ComponentType<MenuComponentProps>;
    setAlertColor: (set: AlertColor) => void;
    setMessage: (set: string) => void;
    setPopupOk: (set: boolean) => void;
    index: number;
}

export function RenderUserMenuOptions({
    MenuOptionComponent,
    setAlertColor,
    setMessage,
    setPopupOk,
    index
}: IRenderUserMenuOptions) {

    return (
        <MenuOptionComponent 
            FooterComponent={CallSuportComponent}
            HeaderComponent={HeaderMenuComponent}
            setAlertColor={setAlertColor}
            setMessage={setMessage}
            setPopupOk={setPopupOk}
            index={index}
        />
    )
}